import classNames from "classnames";

import { createCloudflareLoader } from "utils";
import Image from "components/imageNew/image";
import type { Person } from "content-ui/talks/types";

type TalkPeopleProps = {
  people: Person[];
  className?: string;
  onPersonContactClick?: (person: Person) => void | Promise<void>;
};

const personImageLoader = createCloudflareLoader({
  fit: "scale-down",
  format: "auto",
  gravity: "auto",
});

export const TalkPeople = ({
  people,
  className,
  onPersonContactClick,
}: TalkPeopleProps) => {
  const handleClickOnUserContact = async (person: Person) => {
    if (onPersonContactClick) {
      await onPersonContactClick(person);
    }
  };

  return (
    <div
      className={classNames(
        "grid grid-cols-1 gap-x-[20px] gap-y-[26px] md:grid-cols-2 lg:grid-cols-3",
        className
      )}
    >
      {people.map((person, i) => (
        <div key={i} className="flex gap-x-[10px]">
          {person.image?.url ? (
            <div className="h-[70px] w-[70px] flex-none">
              <Image
                loader={personImageLoader}
                className="h-[70px] w-[70px] object-cover [clip-path:polygon(0_14%,11%_0,100%_0,100%_83%,91%_100%,0_100%)]"
                src={person.image.url}
                width={person.image.width}
                height={person.image.height}
                alt={person.name}
                quality={75}
                sizes="70px"
                placeholder="blur"
                blurDataURL={person.image.blurUpThumb}
              />
            </div>
          ) : null}
          <div className="text-[14px]">
            {person.linkedinUrl || person.twitterUrl ? (
              <a
                href={person.linkedinUrl || person.twitterUrl}
                target={"_blank"}
                className={
                  "font-bold text-[14px] leading-[130%] underline transition-colors [text-underline-position:under] hover:text-cerise"
                }
                rel="noreferrer"
                onClick={async () => {
                  await handleClickOnUserContact(person);
                }}
              >
                {person.name}
              </a>
            ) : (
              <p className={classNames("font-bold")}>{person.name}</p>
            )}
            {person.company ? (
              <p className="">
                {person.role && `${person.role} @ `}
                <span className={"whitespace-nowrap"}>{person.company}</span>
              </p>
            ) : null}
          </div>
        </div>
      ))}
    </div>
  );
};
